import { Outlet } from 'react-router-dom';
import { AdminScopeProvider } from '@/contexts/AdminScopeContext';
import { Header } from './Header';
import { Sidebar } from './Sidebar';
import { MobileNav } from './MobileNav';

export function AdminLayout() {
  return (
    <AdminScopeProvider>
      <div className="min-h-screen bg-background">
        <Header
          showMenuButton={true}
          sidebarContent={<Sidebar />}
        />
      
      <div className="flex">
        {/* Desktop Sidebar */}
        <aside className="hidden md:flex md:w-64 md:flex-col md:fixed md:inset-y-0 md:pt-14 border-r bg-background">
          <Sidebar />
        </aside>

        {/* Main Content */}
        <main className="flex-1 md:pl-64">
          <div className="container mx-auto px-4 py-6 pb-20 md:pb-6 max-w-7xl">
            <Outlet />
          </div>
        </main>
      </div>

      {/* Mobile Bottom Navigation */}
      <MobileNav />
      </div>
    </AdminScopeProvider>
  );
}
